export var getPositioningStyle = function (_a) {
    var side = _a.side, sideOffset = _a.sideOffset, align = _a.align, alignOffset = _a.alignOffset;
    var styles = {};
    switch (side) {
        case 'top':
            styles.bottom = "calc(100% + ".concat(sideOffset, "px)");
            break;
        case 'bottom':
            styles.top = "calc(100% + ".concat(sideOffset, "px)");
            break;
        case 'left':
            styles.right = "calc(100% + ".concat(sideOffset, "px)");
            break;
        case 'right':
            styles.left = "calc(100% + ".concat(sideOffset, "px)");
            break;
        default:
            break;
    }
    switch (align) {
        case 'start': {
            if (side === 'top' || side === 'bottom') {
                styles.left = alignOffset;
            }
            else {
                styles.top = alignOffset;
            }
            break;
        }
        case 'center': {
            if (side === 'top' || side === 'bottom') {
                styles.left = '50%';
                styles.transform = 'translateX(-50%)';
            }
            else {
                styles.top = '50%';
                styles.transform = 'translateY(-50%)';
            }
            break;
        }
        case 'end': {
            if (side === 'top' || side === 'bottom') {
                styles.right = alignOffset;
            }
            else {
                styles.bottom = alignOffset;
            }
            break;
        }
        default:
            break;
    }
    return styles;
};
